<template>
  <div class="column">
    <div class="card" style="margin-top:2px;">
      <div class="card-header">
        <div class="container pec-header">
          <div id="headtext2">{{ getKpiProcessExcellenceKpiName }}</div>
          <performanceitem id="headkpi"
                           :overallByWave="getOverallByWave"
                           :kpi="getKpiProcessExcellence"></performanceitem>
          <WideNscItem :overallByWave="getOverallByWave"
                       :kpi="getKpiProcessExcellence" />
        </div>
      </div>

      <div class="card-body" >

        <div class="il-table">
          <div class="il-row col-15" >
            <!-- Cluster 1 -->
            <div class="il-cell col-3">
              <tableitem :overallByWave="getOverallByWave"
                         :kpi="getKpiContact"
                         :isHeader="true" />
              <titleunderline />

              <div class="dcstart dcoe" v-if="isOnlineGroupPresent()">
                <div class="dchead">{{ $t('Webportal.DashboardBMW.OnlineEnquiry') }}</div>
                <div class="dcinner">
                  <div id="dimmedout">
                    <tableitem  :overallByWave="getOverallByWave"
                                :kpi="getKpiAutoResponse"
                                :kpiPrewave="getKpiAutoResponsePrewave" />
                 </div>
                  <tableitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiPersonalResponse"
                              :kpiPrewave="getKpiPersonalResponsePrewave" />

                  <div class="subitemlostleadsstyle">
                    <tableitem :invertArrow="true"
                              :overallByWave="getOverallByWave"
                              :kpi="getKpiLostLeads1_3"
                              :kpiPrewave="getKpiLostLeads1_3Prewave"
                              :monochrome="true" />
                  </div>

                  <tableitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiQualityOfResponseStandards"
                              :kpiPrewave="getKpiQualityOfResponseStandardsPrewave" />
                  <div id="dimmedout">
                    <tableitem  :overallByWave="getOverallByWave"
                                :kpi="getKpiQualityOfWrittenResponse"
                                />
                  </div>
                  <tableitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiAttemptAppointment"
                              :kpiPrewave="getKpiAttemptAppointmentPrewave" />
                </div>
              </div>

              <div class="dcoe" v-if="isTelephoneGroupPresent()" v-bind:class="{ dcstart : !isOnlineGroupPresent() }"  >
                <div class="dchead">{{ $t('Webportal.DashboardBMW.TelephoneEnquiry') }}</div>
                <div class="dcinner">
                  <tableitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiReachability"
                              />

                 <div class="subitemlostleadsstyle">
                    <tableitem  :invertArrow="true"
                                :overallByWave="getOverallByWave"
                                :kpi="getKpiLostLeads1_7"
                                :monochrome="true" />
                  </div>

                  <tableitem  :overallByWave="getOverallByWave"
                              :kpi="getKpi1_8" />

                  <tableitem  :overallByWave="getOverallByWave"
                              :kpi="getKpi1_9" />
                </div>
              </div>
            </div>

            <!-- Cluster 2 -->
            <div class="il-cell col-3">

              <tableitem  :overallByWave="getOverallByWave"
                          :kpi="getSalesConsultation"
                          :isHeader="true" />
              <titleunderline />

              <div class="dash-card-inner">
                <div id="dimmedout">
                  <tableitem  :overallByWave="getOverallByWave"
                              :kpi="getKpi2_0_9" />
                </div>
                <tableitem  :overallByWave="getOverallByWave"
                            :kpi="getKpi2_0" />

                <tableitem  :overallByWave="getOverallByWave"
                            :kpi="getKpi2_1"
                            :hasDashBorder="false" />

                <div id="dimmedout">
                  <tableitem  :overallByWave="getOverallByWave"
                              :kpi="getKpi2_1_1"
                              :kpiPrewave="getKpi2_1_1Prewave"
                              :hasDashBorder="false" />
                </div>
                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi2_2_1_3"
                           :kpiPrewave="getKpi2_2_1_3Prewave"
                           :hasDashBorder="false" />
                <div id="dimmedout">
                  <tableitem :overallByWave="getOverallByWave"
                            :kpi="getKpi2_2_4_6"
                            :hasDashBorder="false" />
                </div>
                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi2_2_7_1_6"
                           :kpiPrewave="getKpi2_2_7_1_6Prewave"
                           :hasDashBorder="false" />

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi2_3"
                           :hasDashBorder="false" />

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi2_4"
                           :kpiPrewave="getKpi2_4Prewave"
                           :hasDashBorder="false" />
                <div id="dimmedout">
                  <tableitem :overallByWave="getOverallByWave"
                            :kpi="getKpi2_4_1"
                            :kpiPrewave="getKpi2_4_1Prewave"
                            :hasDashBorder="false" />
                </div>
                <div id="dimmedout">
                  <tableitem :overallByWave="getOverallByWave"
                            :kpi="getKpi2_4_2"
                            :hasDashBorder="false" />
                </div>
                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi2_5"
                           :hasDashBorder="false" />
              </div>
            </div>

            <!-- Cluster 3 -->
            <div class="il-cell  col-3">

              <tableitem :overallByWave="getOverallByWave"
                         :kpi="getKpiTestDrive"
                         :isHeader="true" />
              <titleunderline />

              <div class="dash-card-inner">
                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi3_1"
                           :kpiPrewave="getKpi3_1Prewave" />
                <div id="dimmedout">
                  <tableitem :overallByWave="getOverallByWave"
                            :kpi="getKpi3_1_1" />
                </div>
                <div id="dimmedout">
                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi3_1_2" />
                </div>          
                <div id="dimmedout">
                  <tableitem :overallByWave="getOverallByWave"
                            :kpi="getKpi3_1_3" />
                </div>
                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi3_2" />

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi3_2_1" />

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi3_2_2" />

              </div>

              <div style="height: 68px;" />

              <div class="dash-card-inner" v-if="showSalesConsultationExtraItems">
                <div style="height: 20px; font-size: 10pt; font-weight: bold; line-height: 1; margin-left: 10px;">
                  <span>{{$t('Webportal.DashboardBMW.Continued')}}: {{ getSalesConsultationName }}</span>
                </div>

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi2_6_1"
                           :kpiPrewave="getKpi2_6_1Prewave"
                           :hasDashBorder="false" />

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi2_6_2"
                           :kpiPrewave="getKpi2_6_2Prewave"
                           :hasDashBorder="false" />

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi2_7_0_2"
                           :hasDashBorder="false" />
              </div>

            </div>

            <!-- Cluster 4 -->
            <div class="il-cell  col-3">

              <tableitem :overallByWave="getOverallByWave"
                         :kpi="getKpiOffer"
                         :isHeader="true" />
              <titleunderline />

              <div class="dash-card-inner">
                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi4_1"
                           :kpiPrewave="getKpi4_1Prewave" />

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi4_2"
                           :kpiPrewave="getKpi4_2Prewave" />

                <div class="subitemlostleadsstyle" id= "dimmedout">
                  <tableitem :overallByWave="getOverallByWave"
                            :kpi="getKpi4_2_1" />
                </div>

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi4_3"
                           :kpiPrewave="getKpi4_3Prewave" />
                <div id= "dimmedout">
                  <tableitem :overallByWave="getOverallByWave"
                            :kpi="getKpi4_4"
                            :kpiPrewave="getKpi4_4Prewave" />
                </div>
                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi4_5"
                           :kpiPrewave="getKpi4_5Prewave" />

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi4_5_1"
                           :kpiPrewave="getKpi4_5_1Prewave" />

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi4_6" />
                <div id= "dimmedout">
                  <tableitem :overallByWave="getOverallByWave"
                            :kpi="getKpi4_7" />
                </div>
                <div id= "dimmedout">
                  <tableitem :overallByWave="getOverallByWave"
                            :kpi="getKpi4_8" />
                </div>
                <div id= "dimmedout">
                  <tableitem :overallByWave="getOverallByWave"
                            :kpi="getKpi4_9_1" />
                 </div>        
              </div>

            </div>

            <!-- Cluster 5 -->
            <div class="il-cell  col-3">

              <tableitem  :overallByWave="getOverallByWave"
                          :kpi="getKpiFollowUp"
                          :kpiPrewave="getKpiFollowUpPrewave"
                          :isHeader="true" />
              <titleunderline />

              <div class="dash-card-inner">
                <!-- Unterschied zw. "05. Follow-up on Offer" und "09. Follow-up on Offer"? -->
                <tableitem  :overallByWave="getOverallByWave"
                            :kpi="getKpi5_1_0_4"
                            :kpiPrewave="getKpi5_1_0_4Prewave" />
                <div id= "dimmedout">
                  <tableitem  :overallByWave="getOverallByWave"
                              :kpi="getKpi5_1_4_5" />
                </div> 
                <tableitem  :overallByWave="getOverallByWave"
                            :kpi="getKpi5_2_1_2"
                            :kpiPrewave="getKpi5_2_1_2Prewave" />

                <tableitem  :overallByWave="getOverallByWave"
                            :kpi="getKpi5_4"
                            :kpiPrewave="getKpi5_4Prewave" />
              </div>

              <div style="height:121px;"></div>
              <div class="dcstart dcoe" v-if="isKpiGroupPresent('09. CSQ Germany')">
                <div class="dchead">{{ getKpiGroupByString('09. CSQ Germany').KpiName }}</div>
                  <div class="dcinner">
                    <tableitem  :overallByWave="getOverallByWave"
                                :kpi="getKpiDE01" />

                    <tableitem  :overallByWave="getOverallByWave"
                                :kpi="getKpiDE02" />

                    <tableitem  :overallByWave="getOverallByWave"
                                :kpi="getKpiDE03" />
                  </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import performanceitem from './PerformanceItem'
  import tableitem from './TableItem.vue'
  import WideNscItem from './WideNscItem.vue'
  import titleunderline from './TitleUnderline'

  export default {
    name: 'ProcessExcellenceColumnNew',
    data: function(){
      return {
        kpi1 : {},
        lockOnlineGroupPresent : undefined,
        lockTelephoneGroupPresent : undefined
      }
    },

    components: {
      performanceitem,
      tableitem,
      WideNscItem,
      titleunderline
    },

    props:{
      dashdata: Object,
      optionsdata: Object,
      selection: Object,
      isUsedCar: Boolean
    },

    methods:{
      getKpiByString: function (name) {
        if (this.dashdata && this.dashdata.KPI && _.size(this.dashdata.KPI) > 0) {
          let item = _.find(this.dashdata.KPI, (x) => x.KpiCode === name)
          if (item) return item;
        }
      },
      getKpiGroupByString: function (name) {
        if (this.dashdata && this.dashdata.KPIGroup && _.size(this.dashdata.KPIGroup) > 0)
          return _.find(this.dashdata.KPIGroup, (x) => x.KpiCode === name);
      },
      isKpiGroupPresent: function(name) {
        if (this.dashdata && this.dashdata.KPIGroup && _.find(this.dashdata.KPIGroup, ['KpiCode', name]))
          return true;
        return false;
      },
      isTelephoneGroupPresent: function() {
        if (this.lockTelephoneGroupPresent === undefined) {
          var telephoneSurvey = _.find(this.optionsdata.Surveys, 
            item => (_.endsWith(item.label, 'Telephone Integrated 2019') || _.endsWith(item.label, 'Telephone 2019')) &&
                    _.includes(this.selection.Surveys, item.id));
          if (!telephoneSurvey) { return false; }
          var anyData = this.getKpiReachability || this.getKpi1_8 || this.getKpi1_9;
          this.lockTelephoneGroupPresent = anyData;
        }
        return this.lockTelephoneGroupPresent;
      },
      isOnlineGroupPresent: function() {
        if (this.lockOnlineGroupPresent === undefined) {
          var onlineSurvey = _.find(this.optionsdata.Surveys, 
            item => (_.endsWith(item.label, 'Online Integrated 2019') || _.endsWith(item.label, 'Online 2019')) &&
                    _.includes(this.selection.Surveys, item.id));
          if (!onlineSurvey) { return false; }
          var anyData = this.getKpiAutoResponse || this.getKpiPersonalResponse || this.getKpiLostLeads
            || this.getKpiQualityOfResponseStandards || this.getKpiQualityOfWrittenResponse
            || this.getKpiAttemptAppointment;
          this.lockOnlineGroupPresent = anyData;
        }
        return this.lockOnlineGroupPresent;
      },
    },

    computed: {

      getOverallByWave: function() {
        if (this.dashdata && this.dashdata.OverallByWave && _.size(this.dashdata.OverallByWave) > 0)
          return this.dashdata.OverallByWave[0]
        return undefined
      },

      getKpiProcessExcellence: function () {
        return this.getKpiGroupByString('Process Excellence')
      },

      isKpiProcessExcellenceVisible: function () {
        var _kpi = this.getKpiProcessExcellence
        if (!_kpi || !_kpi.SurveyWave || _.size(_kpi.SurveyWave) === 0) {
          return false
        }
        var result =  _kpi.SurveyWave[0].ResultNSC
        return result  != undefined
      },

      getKpiProcessExcellenceKpiName: function() {
        var item = this.getKpiProcessExcellence
        if (item) {
          return item.KpiName
        }
      },

      // Cluster 1: Contact Column
      getKpiContact: function() {
        return this.getKpiByString('01. Contact');
      },
      getKpiAutoResponse: function() {
        return this.getKpiByString('1.2 Auto response (instantly)');
      },
      getKpiAutoResponsePrewave: function() {
        return this.getKpiByString('01. Auto Response (instantly)');
      },
      getKpiPersonalResponse: function() {
        return this.getKpiByString('1.3 Personal response');
      },
      getKpiPersonalResponsePrewave: function() {
        return this.getKpiByString('01. Personal response within 2 working days');
      },
      getKpiLostLeads1_3: function() {
        return this.getKpiByString('1.3 Personal response LL');
      },
      getKpiLostLeads1_3Prewave: function() {
        return this.getKpiByString('Lost Leads');
      },
      getKpiLostLeads1_7: function() {
        return this.getKpiByString('1.7 Reachability LL');
      },
      getKpiQualityOfResponseStandards: function() {
        return this.getKpiByString('1.5 Quality of response: standards');
      },
      getKpiQualityOfResponseStandardsPrewave: function() {
        return this.getKpiByString('03. Quality of Response: Standards');
      },
      getKpiQualityOfWrittenResponse: function() {
        return this.getKpiByString('1.5.1-2 Quality of written response');
      },
      getKpiAttemptAppointment: function() {
        return this.getKpiByString('1.6 Attempt to make an appointment');
      },
      getKpiAttemptAppointmentPrewave: function() {
        return this.getKpiByString('04. Attempt to make an Appointment');
      },
      getKpiReachability: function() {
        return this.getKpiByString('1.7 Reachability');
      },
      getKpi1_8: function() {
        return this.getKpiByString('1.8 Quality of response: standards');
      },
      getKpi1_9: function() {
        return this.getKpiByString('1.9 Attempt to make an appointment');
      },

      // Cluster 2: Sales Consultation Column
      getSalesConsultation: function() {
        return this.getKpiByString('02. Sales consultation')
      },
      getSalesConsultationName: function() {
        let con = this.getSalesConsultation;
        if (!con) return '';
        return con.KpiName;
      },
      getKpi2_0_9: function() {
        return this.getKpiByString('2.0.9 Parking situation at dealership')
      },
      getKpi2_0: function() {
        return this.getKpiByString('2.0 Charging infrastructure')
      },
      getKpi2_1: function() {
        return this.getKpiByString('2.1 Welcome to the dealership')
      },
      getKpi2_1_1: function() {
        return this.getKpiByString('2.1.1 Enquiry Reference')
      },
      getKpi2_1_1Prewave: function() {
        return this.getKpiByString('Enquiry Reference')
      },
      getKpi2_2_1_3: function() {
        return this.getKpiByString('2.2.1-3 Need analysis')
      },
      getKpi2_2_1_3Prewave: function() {
        return this.getKpiByString('2.2 Need analysis')
      },
      getKpi2_2_4_6: function() {
        return this.getKpiByString('2.2.4-6 Need analysis – further topics')
      },
      getKpi2_2_7_1_6: function() {
        return this.getKpiByString('2.2.7.1-6 BMW i need analysis')
      },
      getKpi2_2_7_1_6Prewave: function() {
        return this.getKpiByString('2.2.10 BMW i need analysis')
      },
      getKpi2_3: function() {
        return this.getKpiByString('2.3 Configuration assistance')
      },
      getKpi2_4: function() {
        return this.getKpiByString('2.4 Vehicle presentation')
      },
      getKpi2_4Prewave: function() {
        return this.getKpiByString('02. Vehicle Presentation')
      },
      getKpi2_4_1: function() {
        return this.getKpiByString('2.4.1 Product presentation')
      },
      getKpi2_4_1Prewave: function() {
        return this.getKpiByString('2.4 Was a systematic and customer oriented product presentation conducted?')
      },
      getKpi2_4_2: function() {
        return this.getKpiByString('2.4.2 GKL + vehicle presentation')
      },
      getKpi2_5: function() {
        return this.getKpiByString('2.5 Provision of product information')
      },
      getKpi2_5Prewave: function() {
        if (!this.isUsedCar) {
          return this.getKpiByString('2.6 Provision of product information')
        }
        return this.getKpiByString('2.4 Provision of product information')
      },
      getKpi2_6_1: function() {
        return this.getKpiByString('2.6.1 Home Charging products')
      },
      getKpi2_6_1Prewave: function() {
        return this.getKpiByString('2.5.1 Home Charging products')
      },
      getKpi2_6_2: function() {
        return this.getKpiByString('2.6.2 Public Charging offering')
      },
      getKpi2_6_2Prewave: function() {
        return this.getKpiByString('2.5.1 Public Charging offering')
      },
      getKpi2_7_0_2: function() {
        return this.getKpiByString('2.7.0-2 Government support')
      },
      showSalesConsultationExtraItems: function() {
        return this.getKpi2_6_1 || this.getKpi2_6_2 || this.getKpi2_7_0_2 || this.getKpi2_6_1Prewave || this.getKpi2_6_2Prewave;
      },

      // Cluster 3: Test Drive Column
      getKpiTestDrive: function() {
        return this.getKpiByString('03. Test Drive')
      },
      getKpi3_1: function() {
        return this.getKpiByString('3.1 Test Drive Offer')
      },
      getKpi3_1Prewave: function() {
        return this.getKpiByString('03. Test Drive Offer')
      },
      getKpi3_1_1: function() {
        return this.getKpiByString('3.1.1 GKL + Delivery of test drive vehicle')
      },
      getKpi3_1_2: function() {
        return this.getKpiByString('3.1.2 GKL + Test drive experience')
      },
      getKpi3_1_3: function() {
        return this.getKpiByString('3.1.3 Performance test drive')
      },
      getKpi3_2: function() {
        return this.getKpiByString('3.2 TD procedure requirements')
      },
      getKpi3_2_1: function() {
        return this.getKpiByString('3.2.1 TD further requirements')
      },
      getKpi3_2_2: function() {
        return this.getKpiByString('3.2.2 Accompaniment – Features explained')
      },

      // Cluster 4: Offer Column
      getKpiOffer: function() {
        return this.getKpiByString('04. Offer')
      },
      getKpi4_1: function() {
        return this.getKpiByString('4.1 Provision of price information')
      },
      getKpi4_1Prewave: function() {
        return this.getKpiByString('4.2 Provision of price information')
      },
      getKpi4_2: function() {
        return this.getKpiByString('4.2 Financing product offer given')
      },
      getKpi4_2Prewave: function() {
        return this.getKpiByString('08. Financing Product Offer given')
      },
      getKpi4_2_1: function() {
        return this.getKpiByString('4.2.1 BMW Product')
      },
      getKpi4_3: function() {
        return this.getKpiByString('4.3 New car offer given')
      },
      getKpi4_3Prewave: function() {
        return this.getKpiByString('04. New Car Offer given')
      },
      getKpi4_4: function() {
        return this.getKpiByString('4.4 Additional Services offered')
      },
      getKpi4_4Prewave: function() {
        return this.getKpiByString('4.3 Additional services/packages')
      },
      getKpi4_5: function() {
        return this.getKpiByString('4.5 Retail lead documentation')
      },
      getKpi4_5Prewave: function() {
        return this.getKpiByString('05. Retail Lead Documentation')
      },
      getKpi4_5_1: function() {
        return this.getKpiByString('4.5.1 Correct Spelling')
      },
      getKpi4_5_1Prewave: function() {
        return this.getKpiByString('4.1.1 Were all your contact details spelled correctly in the offer?')
      },
      getKpi4_6: function() {
        return this.getKpiByString('4.6 Trade-in Offer')
      },
      getKpi4_7: function() {
        return this.getKpiByString('4.7 Extension of warranty')
      },
      getKpi4_8: function() {
        return this.getKpiByString('4.8 Marketing opt-in')
      },
      getKpi4_9_1: function() {
        return this.getKpiByString('4.9.1 GKL + nurture program')
      },

      // Cluster 5: FollowUp Column
      getKpiFollowUp: function() {
        return this.getKpiByString('05. Follow up')
      },
      getKpiFollowUpPrewave: function() {
        return this.getKpiByString('05. Follow-up')
      },
      getKpi5_1_0_4: function() {
        return this.getKpiByString('5.1.0-3 Courtesy text message (max. 4 hrs.)')
      },
      getKpi5_1_0_4Prewave: function() {
        return this.getKpiByString('5.1 Courtesy text message')
      },
      getKpi5_1_4_5: function() {
        return this.getKpiByString('5.1.4-5 Courtesy Text Message-further topics')
      },
      getKpi5_2_1_2: function() {
        return this.getKpiByString('5.2.1-2 Follow-up on offer')
      },
      getKpi5_2_1_2Prewave: function() {
        return this.getKpiByString('05. Follow-up on Offer')
      },
      getKpi5_4: function() {
        return this.getKpiByString('5.4 Asking for decision status')
      },
      getKpi5_4Prewave: function() {
        return this.getKpiByString('5.6 Asking for decision')
      },
      getKpiDE01: function() {
        return this.getKpiByString('DE01 Appointment for FU')
      },
      getKpiDE02: function() {
        return this.getKpiByString('DE02 Premium dealership')
      },
      getKpiDE03: function() {
        return this.getKpiByString('DE03 Visitor experience')
      }



    }
  }

</script>

<style scoped>
  .dcstart {
    margin: 11px 0px 2px 0px;
  }
  .dcoe {
    padding: 0px;
    border-width: 2px;
    border-color:  #D0D0D0;
    border-style: solid;
    border-radius: 0px;
  }
  .dchead {
    padding: 0px 4px; font-size: 8pt; font-weight: bold;
  }
  .dcinner{
    padding: 0px 0px;
    margin-inline-start: 2px;
    margin-inline-end: 2px;
    margin-block-start: 2px;
    margin-block-end: 2px;
  }

  #headtext2 {
    height: 24pt;
    text-align: center;
    color: #111111;
    position: relative;
    top: -6px;
    display: inline-block;
    font-weight: 500;
    font-size: 16pt;
    font-stretch: extra-condensed;
  }

  .column {
    margin: 0px;
    padding: 0px;
    position: relative;
    top: 0px;
    margin-block-end: 0px;
    margin-inline-end: 0px;
  }

  .subitemlostleadsstyle {
    margin-inline-start: 36px;
  }

  .col-3{
    padding-left: 0px;
    padding-right: 0px;
    margin-left: 0px;
    margin-right: 0px;
    border-width: 0px;
  }

  .card-header:first-child {
    border-radius: 0rem;
    margin: 0px;
    padding: 0px;
  }

  .card-header {
    background: #d9d9d9;
    border-width: 0px;
    margin: 0px;
    height: 40px;
  }

  .pec-header {
    width: 750px;
    padding-right: 0px;
    padding-left: 0px;
  }

  .card-body {
    padding: 0px;
    margin: 0px;
  }

  .card {
    border: solid #bfbfbf;
    border-width: 2px;
    border-radius: 0rem;
    margin-top: 2px;
    padding: 0px;
    padding-left: 44px;
    height:801px;
  }

  .il-table{
    font-size: 9pt;
    font-size-adjust: inherit;
    height: fit-content;
    width: 100%;
    display: table;
  }

  .il-row {
    width: 100%;
    float: left;
  }

  #dimmedout {
    opacity: 0.5;
    filter: alpha(opacity=50);
  }

  .il-cell {
    float: left;
    width: 20%;
    text-overflow: ellipsis;
    display: table-cell;
  }

  .pec-card{
    float: left;
  }

  .card {
    margin-top: 0px;
    margin-right: 0px;
    margin-bottom: 0px;
    margin-left: 0px;
    padding: 0px;
  }

  h3{
    height: 36pt;
    line-height: 28pt;
    text-align: center;
    float: left;
    top: 0px;
    font-size: 16pt;
    font-stretch: extra-condensed;
  }

</style>
